import {NetworkState, networkStateReducer, post, reset} from "../networkStateReducer";
import {Cart} from "./types";
import {useDispatch, useSelector} from "react-redux";
import {RootState} from "../index";

export const domain = "@appigo-retailer/cart/set/set-order-store-pickup-date"

export const cartSetStorePickupDueDateReducer = networkStateReducer<Cart>(domain)

export function useSetStorePickupDueDate():[NetworkState<Cart>,(dueDate?: string, storePickupDueTime?: string, pickupType?: string) => void, () => void] {
    let dispatch = useDispatch()

    return [
        useSelector<RootState, NetworkState<Cart>>(state => state.cart.setStorePickupDueDate),
        (dueDate, storePickupDueTime, pickupType) => dispatch(post(domain, "/customer-api/v2/cart/set/selected-store-pickup-due-date",{},{ query:{ storePickupDueDate: dueDate ? dueDate : null, storePickupDueTime: storePickupDueTime ? storePickupDueTime : null, pickupType: pickupType ? pickupType : null }})),
        () => dispatch(reset(domain))
    ]

}